import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class TableOfContents {
    constructor() {
        // Document
        this.$window = $(window);
        this.$document = $(document);
        this.$body = $('body');
        this.pageContent = $('.js-single-page');

        // Elements
        this.$header = $('.js-header');
        this.$toc = $('.js-toc-list');
        this.$tocInner = $('.js-toc-inner');
        this.$headings = this.pageContent.find('h2, h3');
        this.$openChapters = $('.js-open-chapters-button');
        this.$tocWrapper = $('.js-table-of-contents-wrapper');
        this.$closeChapters = $('.js-close-chapters-button');
        this.$backgroundOverlay = $('.js-background-overlay');

        // Events
        this.$openChapters.on('click', $.proxy(this.openContent, this));
        this.$closeChapters.on('click', $.proxy(this.closeContent, this));
        this.buildTableOfContents();

        // Needs to run after buildTableOfContents() function as links are
        // dynamically generated
        this.$links = $('.js-chapters-link');
        this.$links.on('click', $.proxy(this.closeContent, this));

        // Scrollbars
        this.$window.on('load', $.proxy(this.addScrollbars, this));

        $(window).on('resize', debounce(() => {
            this.updateScrollbars();

            if (this.$tocWrapper.hasClass('is-open')) {
                this.$body.addClass('is-scroll-locked');
            }
        }, 300));

        this.scrollbars = [];
    }

    openContent(e) {
        const $elem = $(e.currentTarget);
        const $contentToOpen = $elem.find(this.$tocWrapper);

        $elem.addClass('is-open');

        this.$tocWrapper.attr('aria-expanded', 'true');
        this.$tocWrapper.addClass('is-open');
        this.$body.addClass('is-scroll-locked');
        this.$body.addClass('toc-is-open');
        this.$backgroundOverlay.addClass('is-active');

        if (!$elem.hasClass('is-open')) {
            $contentToOpen.attr('aria-expanded', 'false');
        }
    }

    closeContent() {
        this.$tocWrapper.removeClass('is-open');
        this.$body.removeClass('is-scroll-locked');
        this.$body.removeClass('toc-is-open');
        this.$backgroundOverlay.removeClass('is-active');

        if (!this.$tocWrapper.hasClass('is-open')) {
            this.$tocWrapper.attr('aria-expanded', 'false');
        }
    }

    buildTableOfContents() {
        // Only show if there are any headings
        if (this.$headings.length) {
            // Loop through each of the headings
            this.$headings.each((index, element) => {
                // Find the text in each
                const headingText = $(element).text().trim();

                // Create an ID for use on each heading
                const headingID = headingText.trim().toLowerCase().replace(/\s/g, '-');

                $(element).attr('id', headingID);

                if ($(element).is('h2')) {
                    const isTopLevel = true;
                    // Create a list item with the correct URL and ID
                    this.$toc.append(this.buildListItem(headingID, headingText, index, isTopLevel));
                }

                // if h3
                else {
                    // Find the previous heading (i.e the 'parent').
                    const parentListItem = this.$toc.find('> li').last();

                    // If it doesn't already have a sub nav appended, add one.
                    if (!parentListItem.find('> ul').length) {
                        parentListItem.append('<ul class="c-table-of-contents__nested-list"></ul>');
                    }

                    // Find the sub nav and append our list item to it.
                    parentListItem.find('> ul').append(this.buildListItem(headingID, headingText, index));
                }
            });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    buildListItem(headingTarget, headingText, index, isTopLevel = false) {
        let listClass = '';

        if (isTopLevel) {
            listClass = 'class="c-table-of-contents__list-item"';
        } else {
            listClass = 'class="c-table-of-contents__list-item-sub-heading"';
        }
        return `<li ${listClass}>
      <a class="c-table-of-contents__link js-chapters-link" href="#${headingTarget}" title="Anchor link to ${headingText}">${headingText}</a>
    </li>`;
    }

    // addScrollbars () {
    //     for (let i = 0; i < this.$tocInner.length; i++) {
    //         this.scrollbars.push(new Ps(this.$tocInner[0], {
    //             suppressScrollX: true, maxScrollbarLength: 180, wheelSpeed: 0.5,
    //         }));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }
    //
    // destroyScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.destroy());
    // }
}

export default TableOfContents;
